export const dataPolicy = {
  effectiveDate: "1st August 2024",
  sections: [
    {
      title: "Information We Collect",
      body: "We may collect personal and professional information, including:",
      bodyList: [
        "Name, contact details (email, phone number).",
        "Employment history, qualifications, certifications, and other professional details.",
        "Supporting documents, such as CVs or portfolios.",
      ],
    },
    {
      title: "Why We Collect Your Data",
      body: "Your information is collected for:",
      bodyList: [
        "Recruitment and placement in offshore roles.",
        "Legal compliance with employment and industry regulations.",
        "Improving our services and maintaining accurate records.",
      ],
    },
    {
      title: "Legal Basis for Processing",
      body: "Our processing activities are lawful under GDPR, supported by the following:",
      bodyList: [
        "Consent: When you submit your details, you consent to the processing of your data for recruitment purposes.",
        "Legitimate Interests: To ensure effective placement and operational efficiency.",
        "Compliance: To meet legal obligations in employment and data protection.",
      ],
    },
    {
      title: "Data Transfers",
      body: "As we work globally, your data may be transferred to countries outside of the European Economic Area (EEA). These transfers will:",
      bodyList: [
        "Be made in accordance with GDPR and other global regulations.",
        "Use standard contractual clauses or similar safeguards to protect your data.",
      ],
    },
    {
      title: "Data Security",
      body: "We employ strict measures to secure your personal information:",
      bodyList: [
        "Data encryption during transfer and storage.",
        "Restricted access to authorised personnel only.",
        "Routine monitoring and audits to ensure compliance.",
      ],
    },
    {
      title: "Sharing Your Information",
      body: "Your information may be shared with:",
      bodyList: [
        "Potential employers or clients for recruitment purposes.",
        "Third-party providers for services such as background checks, always under strict confidentiality agreements.",
      ],
    },
    {
      title: "Retention Period",
      body: "We will retain your personal information for as long as necessary to fulfil the purposes outlined in this policy or comply with legal requirements. Data no longer required will be securely deleted.",
    },
    {
      title: "Your Rights",
      body: "You have the following rights under GDPR and other privacy laws:",
      bodyList: [
        "Access: Request a copy of the personal data we hold.",
        "Rectification: Correct any inaccurate or incomplete data.",
        "Erasure: Request the deletion of your data (subject to legal obligations).",
        "Restriction: Limit the processing of your data.",
        "Portability: Receive your data in a commonly used format.",
        "Objection: Object to data processing based on legitimate interests.",
      ],
      footer: "To exercise your rights, contact us at info@accesscv.com.",
    },
    {
      title: "Cookies and Tracking Technologies",
      body: "We may use cookies to enhance your online experience. By using our website, you agree to our cookie policy, which is detailed separately on our website.",
    },
    {
      title: "Policy Updates",
      body: "This policy may be updated to reflect changes in legislation or our data processing practices. We recommend regularly reviewing this policy for the latest updates.",
    },
    {
      title: "Contact Us",
      body: "For questions or concerns about your data privacy, please contact:\n📧 Email: info@accesscv.com",
    },
  ],
};
